import { render, staticRenderFns } from "./ScriptsNavMenu.vue?vue&type=template&id=1381ace1"
import script from "./ScriptsNavMenu.vue?vue&type=script&lang=js"
export * from "./ScriptsNavMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports